import { render, staticRenderFns } from "./video.item.vue?vue&type=template&id=6192b101&scoped=true&"
import script from "./video.item.vue?vue&type=script&lang=js&"
export * from "./video.item.vue?vue&type=script&lang=js&"
import style0 from "./video.item.vue?vue&type=style&index=0&id=6192b101&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6192b101",
  null
  
)

export default component.exports